import { NumericFormat } from 'react-number-format'
import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import Cleave from 'cleave.js/dist/cleave-react'

export default function ConvertibleText( {manuallySetPricing, disabled, onChange, onBlurHandler, value: { changePrefix, name, text } }) {
    return (
        <span>
            {manuallySetPricing ? ( !!changePrefix ? (
                <NumericFormat
                className={classNames(
                    'form-control',
                    'number-control',
                    'input-numeral',
                    `input-${name}`,
                    { filled: text }
                )}
                suffix={'%'}
                value={text}
                onValueChange={(event)=> { 
                    return onBlurHandler({
                        [name]:  Number(event.value.replace(/[$,%,+]/g, ''))
                    })
                }}
                />
            ):
                <Cleave
                    className={classNames(
                        'form-control',
                        'number-control',
                        'input-numeral',
                        `input-${name}`,
                        { filled: text }
                    )}
                    disabled={disabled}
                    autoComplete={false}
                    value={text}
                    options={{
                        numeral: true,
                        numeralThousandsGroupStyle: 'thousand',
                        prefix: !!changePrefix ? '' : '$',
                        rawValueTrimPrefix: true
                    }}
                    onChange={onChange}
                    onBlur={(event)=> { 
                        return onBlurHandler({
                            [name]:  Number(event.target.value.replace(/[$,%,+]/g, ''))
                        })
                    }}
                />) :
            (text)}
        </span>
    )
}